import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const PostFinances = {
  Invoices: lazy(() => import('./containers/Invoices_v2/index')),
  Layout: lazyNamed(() => import('./containers/Invoices_v2/components/InvoicePageHeader'), 'InvoicePageHeader'),
};

export default PostFinances;
